import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { Layout } from '../../layouts'
import { Model, type ModelsDataType } from '../../models'
import { ModelRecommendations } from '../ModelRecommendations/ModelRecommendations'

interface MultiModelsRecommendedForYouProps {
  models: ModelsDataType
  whichId: string
  layout: Layout
}

export const MultiModelsRecommendedForYou = ({
  models,
  whichId,
  layout,
}: MultiModelsRecommendedForYouProps) => {
  const showComponent = useFeatureIsOn('r4u-collaborative-filtering-page-level')

  if (showComponent) {
    return (
      <ModelRecommendations model={models[Model.CF_PAGE_LEVEL]} whichId={whichId} layout={layout} />
    )
  }

  return (
    <ModelRecommendations model={models[Model.MIXED_ADVICE]} whichId={whichId} layout={layout} />
  )
}
